export var useFormatChange = function (formatter) { return ({
    onChange: function (event) {
        var target = event.target;
        var value = target.value;
        var formattedValue = formatter ? formatter(value) : null;
        if (typeof formattedValue === 'string') {
            target.value = formattedValue;
        }
    },
}); };
//# sourceMappingURL=use-format-change.js.map